import { useLocale, useTranslator } from "../../i18n/context.js";
import { useContainer, usePlayer } from "../../player/context.js";
import { useDestroy } from "../../utils/use-destroy.js";
import { renderElement } from "../../utils/use-render.js";
import { StatusAnnouncerCore, createStatusAnnouncerLabels } from "@videojs/core";
import { shouldAnnounceStatusChange, subscribeToStatusAnnouncer } from "@videojs/core/dom";
import { forwardRef, useEffect, useState, useSyncExternalStore } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/status-announcer/component.tsx
const StatusAnnouncer = forwardRef(function StatusAnnouncer(componentProps, forwardedRef) {
	const { render, className, style, closeDelay, labels, ...elementProps } = componentProps;
	const translator = useTranslator();
	const locale = useLocale();
	const [core] = useState(() => new StatusAnnouncerCore());
	const store = usePlayer();
	const container = useContainer();
	useDestroy(core);
	core.setProps({
		closeDelay,
		labels: {
			...createStatusAnnouncerLabels(translator, locale),
			...labels
		},
		shouldAnnounce: () => shouldAnnounceStatusChange(container)
	});
	useEffect(() => subscribeToStatusAnnouncer(store, core), [core, store]);
	const state = useSyncExternalStore((callback) => core.state.subscribe(callback), () => core.state.current, () => core.state.current);
	return renderElement("div", {
		render,
		className,
		style
	}, {
		state,
		ref: forwardedRef,
		props: [elementProps, {
			role: "status",
			children: /* @__PURE__ */ jsx("span", {
				"data-status-announcer-content": "",
				children: state.label ?? ""
			}, state.generation)
		}]
	});
});
//#endregion
export { StatusAnnouncer };

//# sourceMappingURL=component.js.map